<div [ngClass]="forOriginOrDestination != 'multiple-destination' ? 'form-group col-md-12 p-0' : 'form-group col-md-12 p-0 mb-0'">
    <div class="d-flex justify-content-end align-items-center flex-end flex-wrap">
        <div class="col-sm-12 col-xs-12 d-flex justify-content-between column-gap-5 py-3 fill-width-available">
            <label *ngIf="isTbdVisible" class="d-flex align-items-center column-gap-10 mb-0">
                <input
                    class="mt-0 checkbox"
                    type="checkbox"
                    [disabled]="selectedAddressType"
                    [(ngModel)]="includeTBD"
                    (change)="onTbdChange()"
                />
                <span>TBD</span>
            </label>
            <div class="d-flex justify-content-end column-gap-5 py-3 fill-width-available">
                <label id="publicAddress" class="d-flex align-items-center column-gap-10 mb-0">
                    <input
                        id="public_{{ dropdownId }}"
                        class="m-0"
                        name="AddressType_{{ dropdownId }}"
                        type="radio"
                        value="public"
                        [disabled]="includeTBD"
                        [(ngModel)]="selectedAddressType"
                        (change)="updateAddressList(); clearSelectedAddress()"
                    />
                    <span>Public</span>
                </label>
                <label id="privateAddress" class="d-flex align-items-center column-gap-10 mb-0">
                    <input
                        id="private_{{ dropdownId }}"
                        class="m-0"
                        name="AddressType_{{ dropdownId }}"
                        type="radio"
                        value="private"
                        [disabled]="includeTBD"
                        [(ngModel)]="selectedAddressType"
                        (change)="updateAddressList(); clearSelectedAddress()"
                    />
                    <span>Private</span>
                </label>
                <label id="airportAddress" class="d-flex align-items-center column-gap-10 mb-0 pr-2">
                    <input
                        id="airport_{{ dropdownId }}"
                        class="m-0"
                        name="AddressType_{{ dropdownId }}"
                        type="radio"
                        value="airport"
                        [attr.data-testid]="'airport-address-radio-' + dropdownId"
                        [disabled]="includeTBD"
                        [(ngModel)]="selectedAddressType"
                        (change)="updateAddressList(); clearSelectedAddress()"
                    />
                    <span>Airport</span>
                </label>
            </div>
        </div>
        <div
            [ngClass]="
                forSRPageOrItinerary == 'SR-Page'
                    ? forOriginOrDestination != 'multiple-destination'
                        ? 'col-xs-12 dropdown-width-sr-page'
                        : 'flex-grow-1'
                    : 'col-xs-12 dropdown-width-itinerary-page pl-0'
            "
        >
            <div *ngIf="selectedAddressType == 'airport'" class="col-sm-12 col-xs-12 px-0 background-white">
                <ng-multiselect-dropdown-angular7
                    id="airportCodes_{{ dropdownId }}"
                    name="airportCodes_{{ dropdownId }}"
                    placeholder="Select Airport Code"
                    [attr.data-testid]="'airportCodes_' + dropdownId"
                    [settings]="airportCodeDropdownSettings"
                    [data]="airportCodeList"
                    [(ngModel)]="selectedAirportCodes"
                    (ngModelChange)="updateAddressList()"
                    (onSelect)="clearSelectedAddress()"
                ></ng-multiselect-dropdown-angular7>
            </div>
        </div>
    </div>
</div>
